module.exports = __webpack_public_path__ + "img/NScoutA64_ua.8a89eadf.webp";